import './Blocked.sass';

import React, { FC, useEffect } from 'react';

import { useCurrentUserInfo, useTranslator } from '$hooks';
import { IcFailed72 } from '$assets';
import { FEED } from '$shared/constants/pages';
import router from '$navigation/router';
import { getDocumentHref } from '$utils';

export const Blocked: FC = () => {
  const t = useTranslator();
  const currentUser = useCurrentUserInfo();

  useEffect(() => {
    if (currentUser.id) {
      router.navigate(FEED);
    }
  }, [currentUser]);

  return (
    <div className="Blocked">
      <div className="Blocked__icon">
        <IcFailed72 />
      </div>
      <div className="Blocked__title">{t('blocked_title')}</div>
      <div className="Blocked__caption">
        {t('blocked_description')}{' '}
        <a href={getDocumentHref('terms')}>{t('blocked_description_terms_link')}</a>.
      </div>
      {/*<div className="Blocked__timer">*/}
      {/*  Блокировка снимается через 5 дней.*/}
      {/*</div>*/}
    </div>
  );
};
